import React, { useEffect, useMemo, useRef, useState } from "react"
import axios from "axios"
import { useNavigate, useSearchParams } from "react-router-dom"
import "../shared/styles/auth.css"
import OdontoFlowLogo from "../shared/brand/OdontoFlowLogo"

function normalizeError(err) {
  const message =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    "No se pudo verificar el correo. Solicita una nueva liga."

  return Array.isArray(message) ? message[0] : message
}

export default function VerifyEmailPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const token = useMemo(() => searchParams.get("token") || "", [searchParams])

  const verificationStartedRef = useRef(false)

  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    if (verificationStartedRef.current) return
    verificationStartedRef.current = true

    async function verify() {
      if (!token) {
        setLoading(false)
        setError("La liga de verificación no contiene token.")
        return
      }

      try {
        setLoading(true)
        setError("")
        setStatus("")

        const { data } = await axios.get("/api/auth/verify-email", {
          params: { token },
        })

        setStatus(
          data?.message ||
            "Correo confirmado correctamente. Ya puedes iniciar sesión.",
        )
      } catch (err) {
        setError(normalizeError(err))
      } finally {
        setLoading(false)
      }
    }

    verify()
  }, [token])

  const title = loading
    ? "Validando liga"
    : error
      ? "Revisión requerida"
      : "Correo confirmado"

  const subtitle = loading
    ? "Verificando correo..."
    : error
      ? error
      : status || "Tu cuenta ya está activa."

  return (
    <div className="of-auth-page">
      <div className="of-auth-bg-glow of-auth-bg-glow-1" />
      <div className="of-auth-bg-glow of-auth-bg-glow-2" />

      <div className="of-auth-shell of-auth-shell--register">
        <section className="of-auth-brand of-auth-brand--compact">
          <div className="of-auth-brand-top">
            <div className="of-auth-badge">Activación de cuenta</div>

            <div className="of-auth-logo-row">
              <OdontoFlowLogo
                theme="dark"
                size="lg"
                showDescriptor
                descriptor="Confirma tu correo para comenzar a operar."
                style={{
                  maxWidth: 520,
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div className="of-auth-divider" />

          <div className="of-auth-feature-list">
            <div className="of-auth-feature">
              <span className="of-auth-feature-icon blue" />
              <div>
                <strong>Cuenta protegida</strong>
                <p>Validamos tu correo antes de activar el acceso.</p>
              </div>
            </div>

            <div className="of-auth-feature">
              <span className="of-auth-feature-icon purple" />
              <div>
                <strong>Acceso seguro</strong>
                <p>Después de confirmar podrás iniciar sesión normalmente.</p>
              </div>
            </div>

            <div className="of-auth-feature">
              <span className="of-auth-feature-icon green" />
              <div>
                <strong>Clínica lista</strong>
                <p>OdontoFlow preparará tu operación inicial.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="of-auth-panel">
          <div className="of-auth-form-wrap">
            <div className="of-auth-form-card">
              <div className="of-auth-form-header">
                <div className="of-auth-form-kicker">
                  {loading ? "Verificando" : error ? "Atención" : "Cuenta activa"}
                </div>

                <h2>{title}</h2>
                <p>{subtitle}</p>
              </div>

              {error ? <div className="of-auth-error">{error}</div> : null}

              {!loading && !error ? (
                <div
                  style={{
                    padding: 12,
                    borderRadius: 16,
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    color: "#166534",
                    fontSize: 13,
                    fontWeight: 800,
                    lineHeight: 1.45,
                    marginBottom: 14,
                  }}
                >
                  Tu correo fue confirmado correctamente. Ya puedes iniciar
                  sesión con tu cuenta.
                </div>
              ) : null}

              {loading ? (
                <div
                  style={{
                    padding: 12,
                    borderRadius: 16,
                    background: "#eff6ff",
                    border: "1px solid #bfdbfe",
                    color: "#1d4ed8",
                    fontSize: 13,
                    fontWeight: 800,
                    lineHeight: 1.45,
                    marginBottom: 14,
                  }}
                >
                  Estamos validando tu liga de activación. Esto tomará unos
                  segundos.
                </div>
              ) : null}

              <button
                className="of-auth-submit"
                type="button"
                disabled={loading}
                onClick={() => navigate("/login")}
              >
                Ir a iniciar sesión
              </button>

              <div className="of-auth-secondary-actions">
                <button
                  type="button"
                  className="of-auth-link-button"
                  onClick={() => navigate("/register")}
                >
                  Crear otra cuenta
                </button>
              </div>

              <div className="of-auth-helper">
                OdontoFlow · Activación segura
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}